jQuery(document).ready(function(){
    jQuery('.multillantas_filtro_btn[category="multillantas_blog_todos"]').addClass('multillantas_btn_activo');

    jQuery('.multillantas_filtro_btn').click(function(){
        var Catmultillantasblog = jQuery(this).attr('category');

        jQuery('.multillantas_filtro_btn').removeClass('multillantas_btn_activo');
        jQuery(this).addClass('multillantas_btn_activo');

        jQuery('.multillantas_blog_item').hide();

        jQuery('.multillantas_blog_item[category="'+Catmultillantasblog+'"]').show();
    });

    jQuery('.multillantas_filtro_btn[category="multillantas_blog_todos"]').click(function(){
        jQuery('.multillantas_blog_item').show();
    });
});